async function http (url: string, options?: any) {
  return await fetch(url, {...options}).then(res => res.json())
}

export default http;